// @flow

import { connect } from 'react-redux';
import MembershipNoModal from './membership-no';
import { closeMembershipModal, copyMembershipNumber } from '../../../services/ui';

export type Props = {
  user: User,
};

const mapState = ({ authentication, ui }) => ({
  user: authentication.user,
  membershipModalIsOpen: ui.membershipModalIsOpen,
  membershipNumberCopied: ui.membershipNumberCopied,
});

const mapDispatch = {
  closeMembershipModal,
  copyMembershipNumber,
};

export default connect(
  mapState,
  mapDispatch,
)(MembershipNoModal);
